export const env = {
  REACT_APP_PASSWORD_MASK_SECRET: process.env.REACT_APP_PASSWORD_MASK_SECRET,
}


